import {action} from 'mobx';
import {HandleTextFieldsChangeFn} from './types';
import {publishCustomizeProductEvent} from '../product-service/publishCustomizeProductEvent';

export const handleCustomTextFieldsChange: HandleTextFieldsChangeFn = (rootStore) =>
  action(({data: {customTextField, index}}) => {
    rootStore.$state.textInput[index] = customTextField;
    publishCustomizeProductEvent(rootStore);
  });
